import { bakimHesapla } from '@/pages/bakim-takip/utils/bakimHesapla';

interface MusteriMesaj {
  id: string;
  ad: string;
  soyad: string;
  telefon: string;
  ilce: string;
  son_bakim_tarihi: string | null;
}

interface Props {
  customers: MusteriMesaj[];
  seciliIds: Set<string>;
  onToggle: (id: string) => void;
  onToggleAll: (val: boolean) => void;
}

const durumCfg = {
  yesil:   { badge: 'bg-emerald-100 text-emerald-700', dot: 'bg-emerald-500' },
  sari:    { badge: 'bg-yellow-100 text-yellow-700',   dot: 'bg-yellow-500' },
  kirmizi: { badge: 'bg-red-100 text-red-700',         dot: 'bg-red-500' },
};

export default function MusteriListesiSupabase({ customers, seciliIds, onToggle, onToggleAll }: Props) {
  const tumSecili = customers.length > 0 && seciliIds.size === customers.length;
  const kismSecili = seciliIds.size > 0 && seciliIds.size < customers.length;

  return (
    <div className="bg-white rounded-xl border border-gray-100">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <input type="checkbox" className="w-4 h-4 rounded cursor-pointer accent-sky-600"
            checked={tumSecili}
            ref={el => { if (el) el.indeterminate = kismSecili; }}
            onChange={e => onToggleAll(e.target.checked)} />
          <span className="text-xs font-semibold text-gray-600">
            {seciliIds.size > 0 ? `${seciliIds.size} müşteri seçildi` : 'Tümünü seç'}
          </span>
        </div>
        <span className="text-xs text-gray-400">{customers.length} müşteri</span>
      </div>
      <div className="divide-y divide-gray-50 max-h-72 overflow-y-auto">
        {customers.length === 0 ? (
          <p className="text-sm text-gray-400 text-center py-8">Bu filtrede müşteri bulunamadı.</p>
        ) : customers.map(c => {
          const bilgi = c.son_bakim_tarihi ? bakimHesapla(c.son_bakim_tarihi) : { ayFarki: 0, durum: 'yesil' as const, etiket: 'Bakım Yok' };
          const stil = c.son_bakim_tarihi ? durumCfg[bilgi.durum] : { badge: 'bg-gray-100 text-gray-500', dot: 'bg-gray-400' };
          const isSecili = seciliIds.has(c.id);
          return (
            <div key={c.id} onClick={() => onToggle(c.id)}
              className={`flex items-center gap-3 px-4 py-3 cursor-pointer transition-colors ${isSecili ? 'bg-sky-50/60' : 'hover:bg-slate-50'}`}>
              <input type="checkbox" className="w-4 h-4 rounded cursor-pointer accent-sky-600 flex-shrink-0" checked={isSecili} onChange={() => onToggle(c.id)} onClick={e => e.stopPropagation()} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-semibold text-gray-800 truncate">{c.ad} {c.soyad}</p>
                  <span className={`hidden sm:inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full font-medium flex-shrink-0 ${stil.badge}`}>
                    <span className={`w-1.5 h-1.5 rounded-full ${stil.dot}`}></span>
                    {'etiket' in bilgi ? bilgi.etiket : 'Bakım Yok'}
                  </span>
                </div>
                <p className="text-xs text-gray-400">{c.telefon} · {c.ilce}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <p className="text-xs text-gray-500 font-medium">{c.son_bakim_tarihi ? `${Math.floor(bilgi.ayFarki)} ay` : '—'}</p>
                <p className="text-xs text-gray-400">önce bakım</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}